import React, { Component } from "react"
import * as dateHelper from "../helpers/date"
import QueryString from "query-string"
import ParkingTimePicker from "../../styleguide/js/components/parking-time-picker"
import DateTimeSelector from "./dateTimeSelector"
import { Forms } from "../../styleguide/js/components/forms"
import Svg from "../../shared/_svgs/svg"
import Truncate from "react-truncate"
import SimpleErrorModal from "../../shared/modal/simple-error-modal"
import "../../helpers/strings"

class BookingStarter extends Component {
  static defaultProps = {
    flow: false,
    campaignCode: true,
    slimVersion: true,
    formClasses: null,
    noHeader: false,
    headline: "headline",
    subHeadline: "",
    modifiers: null,
    backgroundUrl: null,
    inlineColor: null,
    wide: false,
    disclaimer: false,
    replaceHistory: true,
    searchOnBlur: true,
    svgIcon: null,
    searchData: {},
    backgroundColor: "",
    teaser: false,
    bottomPadding: "",
    topPadding: "",
    fontColor: "",
    buttonFontColor: "",
    config: {},
  }

  constructor(props) {
    super(props)
    this.containerRef = React.createRef()
    this.allTimes = [
      "00:30",
      "01:00",
      "01:30",
      "02:00",
      "02:30",
      "03:00",
      "03:30",
      "04:00",
      "04:30",
      "05:00",
      "05:30",
      "06:00",
      "06:30",
      "07:00",
      "07:30",
      "08:00",
      "08:30",
      "09:00",
      "09:30",
      "10:00",
      "10:30",
      "11:00",
      "11:30",
      "12:00",
      "12:30",
      "13:00",
      "13:30",
      "14:00",
      "14:30",
      "15:00",
      "15:30",
      "16:00",
      "16:30",
      "17:00",
      "17:30",
      "18:00",
      "18:30",
      "19:00",
      "19:30",
      "20:00",
      "20:30",
      "21:00",
      "21:30",
      "22:00",
      "22:30",
      "23:00",
      "23:30",
    ]

    let queryParam = props.location && QueryString.parse(props.location.search)
    if (!queryParam) queryParam = QueryString.parse(window.location.search)

    const arrivalLeadTimeHours = this.props.leadTimeInHours
    const arrivalGranularityMilliseconds = 30 * 60 * 1000

    const earliestArrivalTimeStamp = new Date(new Date().getTime() + arrivalLeadTimeHours * 60 * 60 * 1000)
    const arrivalDate = new Date(Math.ceil(earliestArrivalTimeStamp / arrivalGranularityMilliseconds) * arrivalGranularityMilliseconds)
    const departureDate = new Date()
    departureDate.setDate(departureDate.getDate() + 7)
    const durationDays = Math.ceil(Math.abs(new Date(departureDate).getTime() - new Date(arrivalDate).getTime()) / (1000 * 60 * 60 * 24))

    let ad = `${arrivalDate.getFullYear()}-${(arrivalDate.getMonth() + 1).toLocaleString("en-US", { minimumIntegerDigits: 2 })}-${arrivalDate
      .getDate()
      .toLocaleString("en-US", { minimumIntegerDigits: 2 })}`

    let at = `${arrivalDate.getHours().toLocaleString("en-US", { minimumIntegerDigits: 2 })}:${arrivalDate
      .getMinutes()
      .toLocaleString("en-US", { minimumIntegerDigits: 2 })}`
    if (at === "00:00") at = "00:30" // midnight is not a selectable value

    let dd = `${departureDate.getFullYear()}-${(departureDate.getMonth() + 1).toLocaleString("en-US", { minimumIntegerDigits: 2 })}-${departureDate
      .getDate()
      .toLocaleString("en-US", { minimumIntegerDigits: 2 })}`

    if (queryParam.ad) {
      if (queryParam.ad.indexOf("/") > -1) {
        //old format
        ad = dateHelper.formatDateWithPrevFormat(queryParam.ad, "DD/MM/YYYY", "YYYY-MM-DD")
      } else {
        ad = queryParam.ad
      }
    }

    if (queryParam.dd) {
      if (queryParam.dd.indexOf("/") > -1) {
        //old format
        dd = dateHelper.formatDateWithPrevFormat(queryParam.dd, "DD/MM/YYYY", "YYYY-MM-DD")
      } else {
        dd = queryParam.dd
      }
    }

    const adRaw = new Date(ad)
    adRaw.setHours(0, 0, 0, 0)
    const ddRaw = new Date(dd)
    ddRaw.setHours(0, 0, 0, 0)
    const today = new Date()
    today.setHours(0, 0, 0, 0)
    const minday = dateHelper.AddHours(new Date(), props.leadTimeInHours)
    minday.setHours(0, 0, 0, 0)
    today.setHours(0, 0, 0, 0)

    const adFormat = dateHelper.formatDate(adRaw, "DD / MM / YYYY", props.locale)
    const ddFormat = dateHelper.formatDate(ddRaw, "DD / MM / YYYY", props.locale)

    let newAt = at
    let newDt = "17:30"

    if (queryParam.at) {
      if (dateHelper.IsDaylightSavingsChangeDay(adFormat)) {
        if (!(queryParam.at >= "02:00" && queryParam.at < "03:00")) {
          newAt = queryParam.at
        }
      } else {
        newAt = queryParam.at
      }
    } else {
      if (dateHelper.IsDaylightSavingsChangeDay(adFormat)) {
        if (newAt >= "02:00" && newAt < "03:00") {
          newAt = "03:00"
        }
      }
    }

    if (queryParam.dt) {
      if (dateHelper.IsDaylightSavingsChangeDay(ddFormat)) {
        if (!(queryParam.dt >= "02:00" && queryParam.dt < "03:00")) {
          newDt = queryParam.dt
        }
      } else {
        newDt = queryParam.dt
      }
    }

    this.state = {
      ad: adFormat,
      adRaw,
      at: newAt,
      dd: ddFormat,
      ddRaw,
      dt: newDt,
      affiliateCode: queryParam.affiliate,
      voucher: queryParam.voucher,
      inputVoucher: queryParam.voucher || "",
      today: today,
      minday: minday,
      startTimes: this.allTimes,
      endTimes: this.allTimes,
      campaignCodePromptActive: true,
    }

    this.parkingTimePicker = {}
  }

  componentDidMount() {
    const newState = {}

    if (this.state.at) {
      let arrivalTimes = this.allTimes
      const isToday = dateHelper.IsSame(this.state.today, this.state.adRaw)
      const mintime = dateHelper.formatDate(dateHelper.AddHours(new Date(), this.props.leadTimeInHours), "HH:mm", this.props.locale)
      // if chosen date is date that daylight savings starts, remove the void timespan
      if (dateHelper.IsDaylightSavingsChangeDay(this.state.ad)) {
        arrivalTimes = arrivalTimes.filter((t) => t !== "02:00" && t !== "02:30")
        newState["startTimes"] = arrivalTimes
      }
      if (isToday) {
        const newStartTimes = arrivalTimes.filter((t) => t > mintime)
        newState["startTimes"] = newStartTimes
      }
    }
    if (this.state.dt) {
      let departureTimes = this.allTimes
      const isToday = dateHelper.IsSame(this.state.today, this.state.ddRaw)
      const mintime = dateHelper.formatDate(dateHelper.AddHours(new Date(), this.props.leadTimeInHours + 2), "HH:mm", this.props.locale)
      // if chosen date is date that daylight savings starts, remove the void timespan
      if (dateHelper.IsDaylightSavingsChangeDay(this.state.dd)) {
        departureTimes = departureTimes.filter((t) => t !== "02:00" && t !== "02:30")
        newState["endTimes"] = departureTimes
      }
      if (isToday) {
        const newEndTimes = departureTimes.filter((t) => t > mintime)
        newState["endTimes"] = newEndTimes
      }
    }
    this.parkingTimePicker = new ParkingTimePicker({
      el: this.containerRef.current,
      ad: this.state.ad,
      at: this.state.at,
      dd: this.state.dd,
      dt: this.state.dt,
    })

    this.parkingTimePicker.dateTimePair1.setDateRangeStart(this.state.adRaw)
    this.parkingTimePicker.dateTimePair2.setDateRangeStart(this.state.adRaw)

    this.parkingTimePicker.dateTimePair1.setMinDate(this.state.minday)
    this.parkingTimePicker.dateTimePair2.setMinDate(this.state.minday)

    this.parkingTimePicker.dateTimePair1.setDateRangeEnd(this.state.ddRaw)
    this.parkingTimePicker.dateTimePair2.setDateRangeEnd(this.state.ddRaw)

    new Forms({ el: this.containerRef.current })
    this.setState({ ...newState })
  }

  searchParking() {
    const { isInModal, searchData } = this.props
    const { ad, at, dd, dt, voucher, affiliateCode } = this.state
    let activeVoucher = voucher
    if (!activeVoucher) activeVoucher = searchData.voucher

    const formattedDates = {
      ad: dateHelper.formatDateWithPrevFormat(ad, "DD/MM/YYYY", "YYYY-MM-DD"),
      dd: dateHelper.formatDateWithPrevFormat(dd, "DD/MM/YYYY", "YYYY-MM-DD"),
    }
    if (isInModal) {
      this.props.parkingTimeModalToogle()
    }
    if (!this.props.changeFromBooking) {
      this.props.performParkingSearch(
        formattedDates.ad,
        at,
        formattedDates.dd,
        dt,
        activeVoucher,
        searchData.affiliate || affiliateCode,
        this.props.replaceHistory,
        "date",
      )
    } else {
      const { changeFromBooking, ammendmentReference, ammendmentEmail } = this.props
      this.props.performChangeBookingSearch &&
        this.props.performChangeBookingSearch(
          changeFromBooking,
          formattedDates.ad,
          at,
          formattedDates.dd,
          dt,
          activeVoucher,
          searchData.affiliate || affiliateCode,
          ammendmentReference,
          ammendmentEmail,
          true,
        )
    }
  }

  handleFromDateChange(event, searchOnBlur) {
    const { target } = event
    const newFromDateFormatted = target.value
    const newFromDate = dateHelper.getDateFromFormat(newFromDateFormatted, "DD/MM/YYYY")

    const fromDate = dateHelper.getDateFromFormat(this.state.ad, "DD/MM/YYYY")
    const toDate = dateHelper.getDateFromFormat(this.state.dd, "DD/MM/YYYY")

    const isToday = dateHelper.IsSame(this.state.today, newFromDate)
    const isSameDay = dateHelper.IsSame(toDate, newFromDate)
    const mintime = dateHelper.formatDate(dateHelper.AddHours(new Date(), this.props.leadTimeInHours), "HH:mm", this.props.locale)

    const newState = {
      ad: newFromDateFormatted,
      adRaw: newFromDate,
    }

    let arrivalTimes = this.allTimes
    let departureTimes = this.allTimes
    // if chosen date is date that daylight savings starts, remove the void timespan
    if (dateHelper.IsDaylightSavingsChangeDay(newFromDateFormatted)) {
      arrivalTimes = arrivalTimes.filter((t) => t !== "02:00" && t !== "02:30")
      if (this.state.at === "02:00" || this.state.at === "02:30") {
        newState["at"] = ""
      }
    }

    newState["startTimes"] = arrivalTimes

    if (isToday) {
      const newStartTimes = arrivalTimes.filter((t) => t > mintime)
      if (newStartTimes.length > 0 && this.state.at < newStartTimes[0]) {
        newState["at"] = ""
      }
      newState["startTimes"] = newStartTimes
    } else if (!isSameDay) {
      // ensure that we open to time selector to all
      newState["endTimes"] = departureTimes
    }

    if (toDate <= newFromDate) {
      const datediff = dateHelper.DateDiff.inDays(fromDate, toDate)
      const newEndDate = dateHelper.AddDays(newFromDate, datediff)
      const dd = dateHelper.formatDate(newEndDate, "DD/MM/YYYY", this.props.locale)
      // if chosen date is date that daylight savings starts, remove the void timespan
      if (dateHelper.IsDaylightSavingsChangeDay(dd)) {
        departureTimes = departureTimes.filter((t) => t !== "02:00" && t !== "02:30")
        newState["endTimes"] = departureTimes
        if (this.state.dt === "02:00" || this.state.dt === "02:30") {
          newState["dt"] = ""
        }
      }
      this.setState(
        {
          ...newState,
          dd: dd,
          ddRaw: newEndDate,
        },
        () => {
          this.parkingTimePicker.dateTimePair1.setDateRangeStart(newFromDate)
          this.parkingTimePicker.dateTimePair2.setDateRangeStart(newFromDate)
          this.parkingTimePicker.dateTimePair2.setMinDate(newFromDate)
          this.parkingTimePicker.dateTimePair1.setDateRangeEnd(newEndDate)
          this.parkingTimePicker.dateTimePair2.setDateRangeEnd(newEndDate)
          this.parkingTimePicker.dateTimePair2.datePicker.getPicker().gotoDate(newEndDate)
          searchOnBlur && this.searchParking()
        },
      )
    } else {
      this.setState(newState, () => {
        this.parkingTimePicker.dateTimePair1.setDateRangeStart(newFromDate)
        this.parkingTimePicker.dateTimePair2.setDateRangeStart(newFromDate)
        this.parkingTimePicker.dateTimePair2.setMinDate(newFromDate)
        searchOnBlur && this.searchParking()
      })
    }
  }

  handleToDateChange(event, searchOnBlur) {
    const { target } = event
    const newToDateFormatted = target.value

    const fromDate = dateHelper.getDateFromFormat(this.state.ad, "DD/MM/YYYY")
    //const toDate = dateHelper.getDateFromFormat(this.state.dd, 'DD/MM/YYYY')

    const newToDate = dateHelper.getDateFromFormat(newToDateFormatted, "DD/MM/YYYY")

    const isToday = dateHelper.IsSame(this.state.today, newToDate)
    const isSameDay = dateHelper.IsSame(fromDate, newToDate)

    const newState = {
      dd: newToDateFormatted,
      ddRaw: newToDate,
    }

    let allTimes = this.allTimes
    // if chosen date is date that daylight savings starts, remove the void timespan
    if (dateHelper.IsDaylightSavingsChangeDay(newToDateFormatted)) {
      allTimes = allTimes.filter((t) => t !== "02:00" && t !== "02:30")
      if (this.state.dt === "02:00" || this.state.dt === "02:30") {
        newState["dt"] = ""
      }
    }

    newState["endTimes"] = allTimes

    if (isToday) {
      const mintime = dateHelper.formatDate(dateHelper.AddHours(new Date(), this.props.leadTimeInHours + 2), "HH:mm", this.props.locale)
      const newEndTimes = allTimes.filter((t) => t > mintime)
      if (newEndTimes.length > 0 && this.state.at < newEndTimes[0]) {
        newState["dt"] = ""
      }
      newState["endTimes"] = newEndTimes
    } else if (isSameDay) {
      const minDateTimeString = `${newToDateFormatted} ${this.state.at}`
      const minDateTimee = dateHelper.AddHours(dateHelper.getDateFromFormat(minDateTimeString, "DD/MM/YYYY HH:mm"), 1)
      const mintime = dateHelper.formatDate(minDateTimee, "HH:mm", this.props.locale)
      const newEndTimes = allTimes.filter((t) => t > mintime)
      if (newEndTimes.length > 0 && this.state.at < newEndTimes[0]) {
        newState["dt"] = mintime
      }
      newState["endTimes"] = newEndTimes
    }

    this.setState(newState, () => {
      this.parkingTimePicker.dateTimePair1.setDateRangeEnd(newToDate)
      this.parkingTimePicker.dateTimePair2.setDateRangeEnd(newToDate)
      searchOnBlur && this.searchParking()
    })
  }

  handleArrivalTimeChange(event, searchOnBlur) {
    const { target } = event
    const value = target.dataset.value
    // todo validate that time is not after departure time if date is the same
    this.setState({ at: value }, () => {
      searchOnBlur && this.searchParking()
    })
  }

  handleDepartureTimeChange(event, searchOnBlur) {
    const { target } = event
    const value = target.dataset.value
    // todo validate that time is not after departure time if date is the same
    this.setState({ dt: value }, () => {
      searchOnBlur && this.searchParking()
    })
  }

  handleSearchButtonClick(event) {
    this.props.flow && this.parkingTimePicker.handleTogglePreviewMobile(event.currentTarget) //close parkingTimepicker in mobile
    this.searchParking()
  }

  openTooltipModal = () => {
    this.setState({
      showTooltip: true,
      tooltipData: {
        h3: this.props.tooltipHeadline,
        richText: this.props.tooltipText,
      },
    })
  }

  handleModalClose = () => {
    this.setState({ showTooltip: false })
  }

  render() {
    const { ad, at, dd, dt, startTimes, endTimes, campaignCodePromptActive, voucher, inputVoucher } = this.state

    const {
      flow,
      campaignCode,
      formClasses,
      noHeader,
      slimVersion,
      // Test param
      noneInverted,
      isInModal,
      textKeys,
      buttonClasses,
      modifiers,
      wide,
      backgroundUrl,
      inlineColor,
      headline,
      subHeadline,
      disclaimer,
      searchOnBlur,
      button,
      svgIcon,
      teaser,
      backgroundColor,
      bottomPadding,
      topPadding,
      fontColor,
      buttonFontColor,
    } = this.props

    let formModifiers = ""
    /*{{#if formClasses}}{{formClasses}}{{else}}{{#unless slimVersion}} form__section--fat {{/unless}} form__section--split{{/if}}*/
    if (formClasses) {
      formModifiers = formClasses
    } else if (!slimVersion) {
      formModifiers = "form__section--fat"
    } else formModifiers = "form__section--split"

    let buttonModifiers = ""
    /* {{#if buttonClasses}}{{buttonClasses}}{{/if}} {{#unless slimVersion}}button--general button--large {{/unless}} {{#if flow}} button--general-inverted {{/if}} {{#if slimVersion}} button--medium button--general-inverted {{/if}} */
    if (buttonClasses) {
      buttonModifiers += buttonClasses + " "
    }
    if (!slimVersion) {
      buttonModifiers += " button--general button--large"
    }
    if (flow) {
      buttonModifiers += " button--general-inverted"
    }
    if (slimVersion) {
      buttonModifiers += " button--medium button--general-inverted"
    }

    //Test block - not final.
    if (noneInverted) {
      buttonModifiers = "button--medium button--general"
    }

    const tooltip = this.props.tooltipHeadline && this.props.tooltipText && this.props.tooltipPreview && this.props.tooltipReadMore
    const timeFormat = textKeys.timeFormat || "kl. {time}"
    const buttonText = button || textKeys.button || "Book nu"
    const innerControl = (
      <div
        className={`parking-starter-container ${wide && !teaser ? "w--wide" : teaser ? "w--wider" : "w--normal"} ${backgroundColor} ${bottomPadding || "deck--padding-bottom-slim"} ${topPadding || "deck--padding-top-slim"}`}
        ref={this.containerRef}
      >
        {!noHeader ? (
          <div className="parking-time-picker__header">
            {svgIcon ? (
              <span className="icon">
                <svg className={`svg-icon svg-icon--${svgIcon}`}>
                  <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref={`/dist/svg/symbols.svg#svg-${svgIcon}`}>
                    &nbsp;
                  </use>
                </svg>
              </span>
            ) : null}
            <h2 className={`${fontColor ? `${fontColor}` : ""}`} dangerouslySetInnerHTML={{ __html: headline }}></h2>
            {subHeadline ? <p className={`${fontColor ? `${fontColor}` : ""}`}>{subHeadline}</p> : undefined}
          </div>
        ) : (
          ""
        )}
        <div className={`parking-time-picker__form form  js--parking-form${flow ? "" : " show"}`} ref={this.containerRef}>
          {flow ? (
            <React.Fragment>
              <button className="js--toggle-parking-form parking-time-picker__backdrop" />
              <div className="parking-time-picker__mobile-only">
                <p>{textKeys.newSearch || "Ny søgning"}</p>
                <button className="js--toggle-parking-form">
                  <svg className="svg-icon">
                    <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/dist/svg/symbols.svg#svg-close">
                      &nbsp;
                    </use>
                  </svg>
                </button>
              </div>
            </React.Fragment>
          ) : (
            ""
          )}
          <DateTimeSelector
            dateFieldId="ad"
            dateValue={ad}
            dateChangeHandler={this.handleFromDateChange.bind(this)}
            timeFieldId={"at"}
            timeValue={at}
            timeChangeHandler={this.handleArrivalTimeChange.bind(this)}
            timeValueSet={startTimes}
            mainLabel={textKeys.from}
            timeLabel={textKeys.time}
            formModifiers={formModifiers}
            searchOnBlur={searchOnBlur}
          />
          <DateTimeSelector
            dateFieldId="dd"
            dateValue={dd}
            dateChangeHandler={this.handleToDateChange.bind(this)}
            timeFieldId={"dt"}
            timeValue={dt}
            timeChangeHandler={this.handleDepartureTimeChange.bind(this)}
            timeValueSet={endTimes}
            mainLabel={textKeys.to}
            timeLabel={textKeys.time}
            formModifiers={formModifiers}
            searchOnBlur={searchOnBlur}
          />

          {campaignCode ? (
            <React.Fragment>
              <div
                className={`form__section form__section--light parking-time-picker__campaigncode js--campaign-code ${
                  campaignCodePromptActive && !voucher ? "show" : ""
                }`}
              >
                <div id="campaigncodecontainer" className="form__section__inner">
                  <div className="form__field form__field--text is-bound">
                    <span className="form__valid"></span>
                    <input
                      className="form__item "
                      tabIndex=""
                      type="text"
                      id="campaigncode"
                      value={inputVoucher}
                      onChange={(event) => this.setState({ inputVoucher: event.target.value })}
                      onKeyDown={(e) =>
                        e.keyCode === 13 && inputVoucher.length > 0
                          ? this.setState({ campaignCodePromptActive: false, voucher: inputVoucher }, () => this.searchParking())
                          : undefined
                      }
                    ></input>
                    <label htmlFor="campaigncode" className="form__label">
                      <span id="campaigncodelabelinner" className="form__label__text">
                        {textKeys.promotionCode || "KampagnekodeX"}&nbsp;&nbsp;
                        <strong>&nbsp;</strong>
                      </span>
                    </label>
                  </div>
                </div>
                <div id="campaigncodesubmit" className="form__section__inner">
                  <button
                    className=" button--text-link js--applycode parking-time-picker__applycode js--open-modal"
                    data-template="parkingWrongCampaignCodeModalTemplate"
                    onClick={
                      inputVoucher.length > 0
                        ? () => this.setState({ campaignCodePromptActive: false, voucher: inputVoucher }, () => this.searchParking())
                        : undefined
                    }
                  >
                    {textKeys.promotionCodeApply || "Brug"}
                  </button>
                </div>
              </div>
              <div
                className={`form__section form__section--light parking-time-picker__campaigncode-applied js--campaign-code-applied ${
                  voucher ? "show" : ""
                }`}
              >
                <div className="form__section__inner">
                  <span className="t--bold">{voucher}</span>
                </div>
                <div className="form__section__inner">
                  <button
                    className=" button--text-link js--applycode parking-time-picker__applycode"
                    onClick={() => this.setState({ campaignCodePromptActive: true, voucher: "", inputVoucher: "" }, () => this.searchParking())}
                  >
                    {textKeys.promotionCodeRemove || "Fjern"}
                  </button>
                </div>
              </div>
            </React.Fragment>
          ) : (
            ""
          )}

          <div className="form__section parking-time-picker__cta">
            <div className="form__section__inner">
              <button
                className={`button js-book button--large ${buttonModifiers} ${buttonFontColor}`}
                onClick={(e) => this.handleSearchButtonClick(e)}
              >
                <span className="text">{buttonText}</span>
              </button>
            </div>
          </div>
        </div>
        {flow ? (
          <div className="parking-time-picker__preview js--parking-preview">
            <div>
              <p className="text">{dateHelper.formatDateWithPrevFormat(ad, "DD-MM-YYYY", "DD MMM. YYYY")}</p>
              <p className="text-small">{timeFormat.formatUnicorn({ time: at })}</p>
            </div>
            <div>
              <svg className="svg-icon">
                <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/dist/svg/symbols.svg#svg-arrowright-white">
                  &nbsp;
                </use>
              </svg>
            </div>
            <div>
              <p className="text">{dateHelper.formatDateWithPrevFormat(dd, "DD-MM-YYYY", "DD MMM. YYYY")}</p>
              <p className="text-small">{timeFormat.formatUnicorn({ time: dt })}</p>
            </div>
            <button className="parking-time-picker__preview-toggle js--toggle-parking-form">
              <svg className="svg-icon">
                <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/dist/svg/symbols.svg#svg-edit-simple">
                  &nbsp;
                </use>
              </svg>
            </button>
          </div>
        ) : (
          ""
        )}

        {campaignCode ? (
          <button className="js--toggle-parking-form mobile-campaign-btn">{textKeys.promotionCodePrompt || "Kampagnekode?"}</button>
        ) : (
          ""
        )}

        {tooltip ? (
          <div className={"parking-time-picker__tooltip"} onClick={() => this.openTooltipModal()}>
            <Svg iconName={"deliveryquestion"} fillColor={"#FFF"} />
            <div className={"tooltip-text"}>
              <Truncate lines={2} ellipsis={this.props.tooltipReadMore} width={250}>
                {this.props.tooltipPreview}
              </Truncate>
            </div>
          </div>
        ) : null}
        {disclaimer ? (
          <p className={`parking-time-picker__disclaimer ${tooltip ? "more-top-margin" : ""}`}>
            {textKeys.disclaimer || "Begrænsede antal pladser til denne pris"}
          </p>
        ) : null}
        {this.state.showTooltip ? <SimpleErrorModal errorData={this.state.tooltipData} modalOpen={true} closeHandler={this.handleModalClose} /> : ""}
      </div>
    )
    return (
      <div
        className={`parking-time-picker js--parking-time-picker  ${slimVersion ? "parking-time-picker--slim" : ""} ${modifiers ? modifiers : ""} ${
          campaignCodePromptActive ? "parking-time-picker--campaigncode-active" : ""
        }`}
        style={{
          backgroundImage: backgroundUrl ? `url(${backgroundUrl})` : "",
          color: inlineColor ? inlineColor : "",
        }}
      >
        {backgroundUrl ? <div className="parking-time-picker__inner">{innerControl}</div> : innerControl}
      </div>
    )
  }
}

export default BookingStarter
